document.addEventListener("DOMContentLoaded", function () {
  const mtoButtons = document.querySelectorAll("[data-made-to-order-button]");

  // Initialize each MTO button
  mtoButtons.forEach(async (button) => {
    try {
      // Get the MTO product data immediately
      const handle = button.dataset.mtoProductId;
      const response = await fetch(`/products/${handle}.js`);
      const mtoProduct = await response.json();

      // Get the original product's current variant options
      const variantOptions = JSON.parse(button.dataset.variantOptions || "[]");

      // For simplicity, assume size is the last option (check if we have any options)
      if (variantOptions.length > 0) {
        const sizeOption = variantOptions[variantOptions.length - 1];

        // Find matching MTO variant with the same size
        let matchingVariant = mtoProduct.variants.find(
          (variant) => variant.options[variantOptions.length - 1] === sizeOption
        );

        // Update button state based on variant availability
        if (matchingVariant) {
          button.dataset.mtoVariantId = matchingVariant.id;
          const isAvailable = matchingVariant.available;

          // Always update button state
          button.disabled = !isAvailable;

          // Update button text with translations from data attributes
          const textSpan = button.querySelector(".btn__text");
          if (textSpan) {
            const translatedText = isAvailable
              ? button.dataset.textAddToCart || "Add Made-to-Order"
              : button.dataset.textSoldOut || "Sold Out";

            textSpan.textContent = translatedText;
          }
        } else {
          // No matching variant found
          button.disabled = true;
          const textSpan = button.querySelector(".btn__text");
          if (textSpan) {
            textSpan.textContent = button.dataset.textSoldOut || "Sold Out";
          }
        }
      }

      // Add click handler
      button.addEventListener("click", handleButtonClick);
    } catch (error) {
      console.error("Error initializing MTO button:", error);
      // Set to disabled on error
      button.disabled = true;
    }
  });

  // Handle button click
  async function handleButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget;

    if (button.classList.contains("loading") || button.disabled) {
      return;
    }

    try {
      button.classList.add("loading");
      button.disabled = true;

      const selectedVariantId = button.dataset.mtoVariantId;
      if (!selectedVariantId) {
        throw new Error("No matching MTO variant available");
      }

      const formData = new FormData();
      formData.append("id", selectedVariantId);
      formData.append("quantity", 1);

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        formData.append("sections", "api-cart-items");
        formData.append("sections_url", window.location.pathname);
      }

      const cartResponse = await fetch(`/cart/add.js`, {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      });

      const cartData = await cartResponse.json();
      if (cartData.status) {
        throw new Error(cartData.description || "Error adding to cart");
      }

      document.dispatchEvent(
        new CustomEvent("theme:cart:refresh", { bubbles: true })
      );

      if (cartDrawer) {
        cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
      } else {
        window.location = "/cart";
        return;
      }

      button.classList.remove("loading");
      button.classList.add("is-added");

      setTimeout(() => {
        button.classList.remove("is-added");
        button.disabled = false;
      }, 1000);
    } catch (error) {
      console.error("Made-to-order error:", error);
      button.classList.remove("loading");
      button.disabled = false;
    }
  }

  // Listen for variant changes
  document.addEventListener("theme:variant:change", function (event) {
    const variant = event.detail.variant;
    const mtoButton = event.target.querySelector("[data-made-to-order-button]");

    if (!mtoButton || !variant || !variant.options) return;

    updateMtoButtonForVariant(mtoButton, variant.options);
  });

  // Update MTO button when variant changes
  async function updateMtoButtonForVariant(button, variantOptions) {
    try {
      button.dataset.variantOptions = JSON.stringify(variantOptions);

      // Get the MTO product data
      const handle = button.dataset.mtoProductId;
      const response = await fetch(`/products/${handle}.js`);
      const mtoProduct = await response.json();

      // Assume size is the last option
      const sizeOption = variantOptions[variantOptions.length - 1];

      // Find matching MTO variant with the same size
      let matchingVariant = mtoProduct.variants.find(
        (variant) => variant.options[variantOptions.length - 1] === sizeOption
      );

      // Update button state
      if (matchingVariant) {
        button.dataset.mtoVariantId = matchingVariant.id;
        const isAvailable = matchingVariant.available;

        button.disabled = !isAvailable;

        const textSpan = button.querySelector(".btn__text");
        if (textSpan) {
          const translatedText = isAvailable
            ? button.dataset.textAddToCart || "Add Made-to-Order"
            : button.dataset.textSoldOut || "Sold Out";

          textSpan.textContent = translatedText;
        }
      } else {
        button.disabled = true;
        const textSpan = button.querySelector(".btn__text");
        if (textSpan) {
          textSpan.textContent = button.dataset.textSoldOut || "Sold Out";
        }
      }
    } catch (error) {
      console.error("Error updating MTO button:", error);
      button.disabled = true;
    }
  }
});
